import { colors } from 'Constants/Colors';

export const CardStyle = {
  display: 'flex',
  width: '49%',
  minWidth: '25rem',
  marginBottom: '1rem',
  cursor: 'pointer',
};

const CHIP_MAX_WIDTH = 300;
const CHIP_ICON_WIDTH = 16;

export const chipStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  border: 'none',
  textOverflow: 'ellipsis',
  maxWidth: CHIP_MAX_WIDTH - CHIP_ICON_WIDTH,
};

export const CardMediaStyle = {
  width: 151,
  minHeight: '15vh',
  margin: 2,
  borderRadius: '15px',
};

export const EmptyCardMediaStyle = {
  width: 151,
  minHeight: '15vh',
  margin: '1rem',
  borderRadius: '15px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: `${colors.GRAY}`,
  fontSize: '2rem',
};

export const CardMain = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

export default {
  chipStyle,
  CardMain,
  CardMediaStyle,
  EmptyCardMediaStyle,
  CardStyle,
};
